import * as ko from "knockout";
import Bao from "./../../services/bao-service";

/**
 * Model for the ShiftScheduleEditCell Dialog in TeamSchedule
 * */
class ShiftScheduleEditCellDialog {
    Bao = Bao;
    Parent: any;

    EmployeeId: KnockoutObservable<string> = ko.observable("");
    EmployeeName: KnockoutObservable<string> = ko.observable("");
    ShiftTypeId: KnockoutObservable<string> = ko.observable("");
    ShiftGroupId: KnockoutObservable<string> = ko.observable("");
    Code: KnockoutObservable<string> = ko.observable("");
    Date: KnockoutObservable<string> = ko.observable("");
    VacationName: KnockoutObservable<string> = ko.observable("");
    Remark: KnockoutObservable<string> = ko.observable("");
    IsVario: KnockoutObservable<boolean> = ko.observable(false);
    ShiftTypeIsVarioShift: KnockoutObservable<boolean> = ko.observable(false);
    ShiftTypeObject = ko.observable<any>();
    OrginalShiftTypeCode: KnockoutObservable<string> = ko.observable("");
    OrginalShiftTypeId: KnockoutObservable<string> = ko.observable("");
    SyncId: KnockoutObservable<number> = ko.observable();

    SearcherShiftType: Bindings.baoSearcher = {
        ObjectId: this.ShiftTypeId,
        ObjectValue: 'Code',
        SelectedItem: this.ShiftTypeObject,
        SearchType: 'ShiftType',
        AutoSearch: true,
        Enabled: true,
        CustomFilter: {
            ActiveForShiftplan: true
        }
    };

    constructor(parent: any, selectedCellData: any) {
        this.Parent = parent;

        // Initialize from selected data if it exists
        if (selectedCellData) {
            const employee = parent.Employees().filter(e => e.Id === selectedCellData.EmployeeId)[0];

            this.EmployeeId(selectedCellData.EmployeeId);
            this.EmployeeName(selectedCellData.EmployeeName);
            this.ShiftTypeId(selectedCellData.ShiftTypeId);
            this.ShiftGroupId(employee.ShiftGroupId);
            this.Code(selectedCellData.Code);
            this.Date(selectedCellData.Date);
            this.VacationName(selectedCellData.VacationName);
            this.Remark(selectedCellData.Remark);
            this.IsVario(selectedCellData.IsVario);
            this.ShiftTypeIsVarioShift(selectedCellData.ShiftTypeIsVarioShift);
            this.OrginalShiftTypeId(selectedCellData.OrginalShiftTypeId);
            this.OrginalShiftTypeCode(selectedCellData.OrginalShiftTypeCode);
            this.SyncId(selectedCellData.SyncId);
        }

        this.ShiftTypeObject.subscribe((newValue) => {
            if (newValue != null) {
                this.ShiftTypeId(newValue.ShiftTypeId);
                this.ShiftTypeIsVarioShift(newValue.IsVarioShift);
                if (!this.ShiftTypeIsVarioShift()) {
                    this.IsVario(false);
                }
            }
        });
    }

    ItemCompleteCheck() {
        return true;
    }
}
export default ShiftScheduleEditCellDialog;